import { formatNumber } from '@angular/common';
import * as Chart from 'chart.js';

export * from './language';
export * from './error';
export * from './paths';
export * from './request-data';

var theHelp = Chart.helpers;

export const
  HTTP_HEADER_CONTENT_TYPE = 'Content-Type',
  HTTP_HEADER_AUTHORIZATION = 'Authorization',
  MIME_TYPE_JSON = 'application/json',
  HTTP_HEADER_CONSOLIDATOR_CODE = "Deconsolidator-Code",
  HTTP_HEADER_MODULE_CODE = "Module-Code",
  HTTP_HEADER_ACCESS_CONTROL_REQUEST_HEADERS = "Access-Control-Request-Headers",
  HTTP_HEADER_ACCESS_CONTROL_ALLOW_HEADERS = "Access-Control-Allow-Headers",
  HTTP_TOKEN = "Token",

  PATTERN_LETTERS= '^[a-zA-Z]*$',
  PATTERN_LETTERS_WITH_SPACE = '^[a-zA-Z ]*$',
  PATTERN_LETTERS_WITH_SPACE_HYPHEN = '^[a-zA-Z- ]*$',
  PATTERN_LETTERS_WITH_SPACE_PERIOD = '^[a-zA-Z. ]*$',
  PATTERN_ALPHA_NUMERIC_SPACE_ONLY = '.*\\S.*[a-zA-z0-9 ]',
  PATTERN_ALPHA_NUMERIC_NO_SPACE = '^\\s*[a-zA-Z0-9]*\\s*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPACE = '^[a-zA-Z0-9 ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPACE_HYPHEN = '^[a-zA-Z0-9- ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_SPC_CHAR = '^[a-zA-Z0-9-_. ]*$',
  PATTERN_ALPHA_NUMERIC_WITH_CHAR = '^[a-zA-Z0-9-_.]*$',
  PATTERN_NUMERIC = '^[0-9-]*$',
  PATTERN_NUMERIC_WITH_SIGN = '^-*[0-9]+$',
  PATTERN_NUMERIC_WITH_SPACE = '^[0-9 _ ,+]*$',
  PATTERN_DECIMAL = '^-*[0-9]*(\.[0-9]{0,2})?$',
  PATTERN_DECIMAL_WITH_SIGN = '^-*[0-9]*(\.[0-9]{0,2})?$',
  PATTERN_NUMERIC_NEGATIVE = '^-[0-9]*$',
  PATTERN_EMAIL = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$', 
  PATTERN_NO_SPACE = '^([^ ])*$',
  PATTERN_WEEK = '^([1-9]|[1234][0-9]|5[0-2])-([0-9]{4})$',
  PATTERN_WEEK_NUMBER = '^([1-9]|[1234][0-9]|5[0-2])-([0-9]{1,})$',
  PATTERN_WEEK_FORMAT = '^(.{1,2})-(.{4})$',
  PATTERN_V5_CUSTOMER_CODE = '^[V]([0-9]{9})',
  PATTERN_RESTRICTED_FILENAME_CHARS = '^[^/\\\\:\*"<>|]*$',
  PATTERN_DATE = '/(([0-2]?\d{1})|([3][0,1]{1}))/^[0,1]?\d{1}/(([1]{1}[9]{1}[9]{1}\d{1})|([2-9]{1}\d{3}))$/',

  DATETIME_FORMAT_FILE_PREFIX_S3 = "YYYYMMDDHHmmssSSS",
  DATE_FORMAT_YM_REQUEST = "YYYY-MM",
  DATE_FORMAT_YMD_REQUEST = "YYYY-MM-DD",

  DATETIME_FORMAT_REQUEST = "YYYY-MM-DD HH:mm:ss",

  FILTER_DEFAULT_START_TIME = "00:00:00",
  FILTER_DEFAULT_END_TIME = "23:59:00",

  ONHOLD_STATUS = "On-hold",
  SHORTLANDED_STATUS = "Shortlanded",
  OVERLANDED_STATUS = "Overlanded",

  SHOW_DATA = "SHOW_DATA",
  SHOW_S3 = "SHOW_S3",
  SEND_EMAIL = "SEND_EMAIL",
  
  STRIPPING_BY_YARD = "YARD",
  STRIPPING_BY_SF = "SF",
  STRIPPING_BY_STRIPPED = "STRIPPED",
  STRIPPING_BY_RELEASED = "RELEASED",
  MESSAGE_SUCCESS = "Success",
  
  MULTILINE_CHART_OPTION = {
    scaleShowVerticalLines: false,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'bottom'
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 40,
        bottom: 10
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].toolTipLabel || '';
          // let label = 'Consignee Count';
          if (label) {
            label += ': ';
          }
          label += formatNumber(tooltipItem.yLabel, window.navigator.language, '1.0-2');
          return label;
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'top',
        formatter: (num) => {
          let fixed = 2;
          if (num === null) { return null; } // terminate early
          if (num === 0) { return '0'; } // terminate early
          fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
          let b = (num).toPrecision(2).split("e"), // get power
            k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
            d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
            e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
          return e;
        }
      }
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            display: false
          },
          ticks: {
            beginAtZero: true,
            userCallback: function (label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            }
          },
          // scaleLabel: {
          //     display: true,
          //     labelString: '1k = 1000'
          // }
        }
      ],
      xAxes: [
        {
          gridLines: {
            display: false
          },
          offset: true,
          ticks: {
            // callback: function (value) {
            //   return _.truncate(value, { length: 10 });
            // }
          }
        }
      ]
    }
  },
  BAR_CHART_OPTION = {
    scaleShowVerticalLines: false,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 40,
        bottom: 10
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].toolTipLabel || '';

          if (label) {
            label += ': ';
          }
          label += formatNumber(tooltipItem.yLabel, window.navigator.language, '1.0-2');
          return label;
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'top',
        formatter: (num) => {
          let fixed = 2;
          if (num === null) { return null; } // terminate early
          if (num === 0) { return '0'; } // terminate early
          fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show

          let b = (num).toPrecision(4).split("e"); // get power

          let k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions

          let c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed); // divide by power

          let d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
          d = (d % 1 != 0) ? parseFloat(d).toFixed(3) : d;

          let e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
          return e;
        }
      }
    },
    scales: {
      yAxes: [
        {
          gridLines: {
            display: false
          },
          ticks: {
            beginAtZero: true,
            callback: function (num) {
              let fixed = 2;
              if (num === null) { return null; } // terminate early
              if (num === 0) { return '0'; } // terminate early
              fixed = (!fixed || fixed < 0) ? 0 : fixed; // number of decimal places to show
              let b = (num).toPrecision(2).split("e"); // get power
              let k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions
              let c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed); // divide by power
              let d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
              if (Math.floor(d) === d) {
                let e = d + ['', 'K', 'M', 'B', 'T'][k]; // append power
                return e;
              }
            }
          }
          // ticks: {
          //   beginAtZero: true,
          //   userCallback: function (label, index, labels) {
          //     // when the floored value is the same as the value we have a whole number
          //     if (Math.floor(label) === label) {
          //       return label;
          //     }

          //   }
          // },
          // scaleLabel: {
          //     display: true,
          //     labelString: '1k = 1000'
          // }
        }
      ],
      xAxes: [
        {
          gridLines: {
            display: false
          },
          ticks: {
            // callback: function (value) {
            //   return _.truncate(value, { length: 10 });
            // }
          }
        }
      ]
    }
  },

  PIE_CHART_OPTIONS = {
    scaleShowVerticalLines: false,
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'left',
      labels: {
        boxWidth: 5,
        padding: 5,
        generateLabels: function (chart) {
          var data = chart.data;
          if (data.labels.length && data.datasets.length) {
            data.labels = data.labels.sort();
            return data.labels.map(function (label, i) {
              var title = label.substring(0, label.indexOf("-"));
              var meta = chart.getDatasetMeta(0);
              var ds = data.datasets[0];
              var sum = 0;
              var dataArr = data.datasets[0].data;
              dataArr.map(data => {
                sum += data;
              });
              var arc = meta.data[i];
              var custom = arc && arc.custom || {};
              var getValueAtIndexOrDefault = theHelp.getValueAtIndexOrDefault;
              var arcOpts = chart.options.elements.arc;
              var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
              var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
              var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
              return {
                // And finally : ds.data[i] + "% of the time " +  
                text: title + ' - ' + ((ds.data[i]) * 100 / sum).toFixed(2) + "%",
                fillStyle: fill,
                strokeStyle: stroke,
                lineWidth: bw,
                hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                index: i
              };
            });
          }
          return [];
        }
      }
    },
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          let title = data.labels[tooltipItem[0].index].split("-");
          return title[0];
        },
        label: function (tooltipItem, data) {
          let sum = 0;
          let dataArr = data.datasets[0].data;
          dataArr.map(data => {
            sum += data;
          });
          let label;
          label = data.datasets[0].toolTipLabel + ": " + data.datasets[0].data[tooltipItem.index] + ' (' + (data.datasets[0].data[tooltipItem.index] * 100 / sum).toFixed(2) + "%)";
          return label;
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            sum += data;
          });
          let percentage = (value * 100 / sum).toFixed(2) + "%";
          return value;
        },
        display: false,
        color: "white"
      }
    },
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 10
      }
    }
  }
  ;

  export enum StrippingTallySheetPrintType { 
    Stripping = "S",
    Consolidator = "C",
    Releasing = "R"
  }